import { Link } from "react-router-dom";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  Video01Icon,
  ShoppingBag01Icon,
  MusicNote01Icon,
  ArrowRight01Icon,
} from "@hugeicons/core-free-icons";
import { cn } from "@/lib/utils";

const templates = [
  {
    title: "YouTube Shorts",
    description:
      "Generate YouTube Shorts with AI-scripted scenes, generated visuals, and voiceover.",
    icon: Video01Icon,
    modules: 7,
  },
  {
    title: "Product Showcase",
    description:
      "Turn product photos into polished video showcases with transitions, music, and captions.",
    icon: ShoppingBag01Icon,
    modules: 5,
  },
  {
    title: "Music Video Generator",
    description:
      "Create visual music videos from a text prompt with scene generation and beat-synced editing.",
    icon: MusicNote01Icon,
    modules: 6,
  },
];

export function TemplatesV2() {
  return (
    <section className="py-24 bg-muted/30 dark:bg-white/2">
      <div className="mx-auto max-w-5xl px-6">
        {/* Section heading */}
        <div className="text-center">
          <p className="text-brand text-xs font-semibold uppercase tracking-widest">
            Templates
          </p>
          <h2 className="font-display text-foreground mt-4 text-4xl tracking-normal sm:text-5xl">
            Start with a pre-built pipeline
          </h2>
        </div>

        {/* Template cards */}
        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-3">
          {templates.map((template) => (
            <div
              key={template.title}
              className="group flex flex-col items-center rounded-2xl border border-black/5 bg-card p-6 shadow-sm transition-colors hover:border-black/10 dark:border-white/10 dark:bg-white/5 dark:hover:border-white/20"
            >
              {/* Icon badge */}
              <div className="bg-brand-muted flex size-10 items-center justify-center rounded-lg">
                <HugeiconsIcon
                  icon={template.icon}
                  className={cn("text-brand size-5")}
                />
              </div>

              <h3 className="text-foreground mt-4 text-base font-semibold">
                {template.title}
              </h3>
              <p className="text-muted-foreground mt-1 text-xs">
                {template.modules} modules
              </p>
              <p className="text-muted-foreground mt-3 text-sm leading-relaxed text-center">
                {template.description}
              </p>

              <Link
                to="/templates"
                className="text-brand mt-4 inline-flex items-center gap-1 text-sm font-medium opacity-0 transition-opacity group-hover:opacity-100"
              >
                Use template
                <HugeiconsIcon icon={ArrowRight01Icon} className="size-3.5" />
              </Link>
            </div>
          ))}
        </div>

        {/* Browse all link */}
        <div className="mt-10 text-center">
          <Link
            to="/templates"
            className="text-foreground hover:text-foreground/70 inline-flex items-center gap-1.5 text-sm font-medium underline underline-offset-4 transition-colors"
          >
            Browse all templates
            <HugeiconsIcon icon={ArrowRight01Icon} className="size-3.5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
